import { defineComponent as _defineComponent } from 'vue'
import { HatchStyle, PlantVariety } from 'farmdok-rest-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapHatchCheckerboard',
  props: {
    variety: null
  },
  setup(__props: any) {



return { __sfc: true,HatchStyle }
}

})